import { useMemo } from 'react';

import { ColDef } from 'ag-grid-community';

import { useEmbryoInventoryColumns } from './embryo-inventory';

const plateNumberColumn: ColDef = {
  field: 'plateNumber',
  headerName: 'Plate #',
  width: 80,
  filter: 'agNumberColumnFilter',
  wrapHeaderText: true,
  filterParams: { buttons: ['apply', 'clear'], closeOnApply: true },
  sortable: true,
};

export function useIvfTransitEmbryosColumns() {
  const embryoColumns = useEmbryoInventoryColumns();

  return useMemo<ColDef[]>(
    () => [
      ...embryoColumns.slice(0, 21),
      plateNumberColumn,
      ...embryoColumns.slice(21),
    ],
    [embryoColumns],
  );
}
